module.exports = {
      id: "e6bafa931cc4122b5675f1238745d3a2roofShape-saddle.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#e6bafa931cc4122b5675f1238745d3a2roofShape-saddle.svg",
      toString: function () {
        return this.url;
      }
    }